import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSparkfunComponent } from './simple-icons-sparkfun.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSparkfunComponent ],
    exports:      [ SimpleIconsSparkfunComponent ],
    bootstrap:    []
})
export class SimpleIconsSparkfunModule {}
